import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-14">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-400 mb-4">
            Shop By
          </p>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-tight">
            Curated Collections
          </h2>
          <p className="mt-4 text-foreground-500 text-base md:text-lg max-w-xl">
            Browse our <strong className="font-semibold text-foreground-800">updated vigorbuy spreadsheet</strong> categories with thousands of verified products.
          </p>
        </div>

        {/* Category Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, index) => {
            const isLarge = index === 0;
            const isDark = index % 4 === 0 && index !== 0;

            return (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`group relative overflow-hidden rounded-3xl transition-all duration-300 hover:scale-[1.02] cursor-pointer ${
                  isLarge ? 'sm:col-span-2 sm:row-span-1' : ''
                } ${
                  isDark ? 'bg-foreground-900' : 'bg-background-50'
                }`}
                style={{ minHeight: isLarge ? '320px' : '280px' }}
              >
                {/* Background Image */}
                <div className="absolute inset-0">
                  <img
                    src={cat.imageUrl}
                    alt={`${cat.name} - Vigorbuy Spreadsheet Category`}
                    title={`${cat.name} - Vigorbuy Spreadsheet`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className={`absolute inset-0 ${
                    isDark
                      ? 'bg-gradient-to-t from-foreground-900/90 via-foreground-900/40 to-transparent'
                      : 'bg-gradient-to-t from-black/50 via-black/20 to-transparent'
                  }`}></div>
                </div>

                {/* Card Content */}
                <div className="relative z-10 h-full flex flex-col justify-end p-6 md:p-8">
                  <div className="flex items-center gap-3 mb-2">
                    <span className={`w-8 h-8 flex items-center justify-center rounded-full ${
                      isDark ? 'bg-white/15' : 'bg-white/20'
                    }`}>
                      <i className={`${cat.icon} text-sm ${isDark ? 'text-white/90' : 'text-white'}`}></i>
                    </span>
                    <span className={`text-xs font-medium uppercase tracking-wider ${
                      isDark ? 'text-white/60' : 'text-white/70'
                    }`}>
                      {cat.productCount} Products
                    </span>
                  </div>
                  <h3 className={`text-xl md:text-2xl font-bold ${
                    isDark ? 'text-white' : 'text-white'
                  } font-heading`}>
                    {cat.name}
                  </h3>
                  <div className="mt-3 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-sm font-medium text-white/80">
                      Browse Collection
                    </span>
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-sm text-white/80"></i>
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>

        {/* View All Link */}
        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-foreground-600 hover:text-foreground-900 text-sm font-semibold transition-colors duration-200 cursor-pointer"
          >
            View All Categories on Kaspreadsheet
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}